import { get } from 'lodash';

export class PaymentForm {
  name: string | undefined;
  no: string | undefined;
  bank: string | undefined;
  isAuthorised: boolean | undefined;
  others: string | undefined;
  constructor(initial: any) {
    this.name = get(initial, 'name', undefined);
    this.no = get(initial, 'no', undefined);
    this.bank = get(initial, 'bank', undefined);
    this.isAuthorised = get(initial, 'isAuthorised', undefined);
    this.others = get(initial, 'others', undefined);
  }
}